(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
console.log("hun");
  document.querySelectorAll(".faq-question").forEach(function (button) {
    button.addEventListener("click", function () {
      const faqItem = this.closest(".faq-item");
      const answer = faqItem.querySelector(".faq-answer");

      this.classList.toggle("active");
      answer.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
